function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.416 2a5 5 0 110 10 5 5 0 010-10zm0 2a.5.5 0 00-.5.5V7a.5.5 0 00.146.354l1.5 1.5a.5.5 0 00.707-.707L5.916 6.792V4.5a.5.5 0 00-.5-.5zM12.416 3.827c0-.149.061-.291.17-.396A.597.597 0 0113 3.267c.155 0 .304.059.413.164.11.105.171.247.171.396v4.48a.548.548 0 01-.17.396.597.597 0 01-.414.164.597.597 0 01-.413-.164.548.548 0 01-.171-.396v-4.48zm0 6.346c0-.148.061-.29.17-.396A.597.597 0 0113 9.613c.155 0 .304.06.413.164.11.105.171.248.171.396a.548.548 0 01-.17.396.598.598 0 01-.414.164.598.598 0 01-.413-.164.548.548 0 01-.171-.396z",
  fill: "currentColor"
});

var SvgTimeout = function SvgTimeout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgTimeout;